// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"0b05159f","453":"211be4f6","465":"3dfbe8ca","584":"1a31a6d8","863":"d15c6677"}[chunkId] + ".chunk.js";
};